function w(e) {
  "@babel/helpers - typeof";
  return w = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, w(e);
}
function y(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function b(e) {
  y(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || w(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
var j = 6e4;
function C(e, t) {
  return y(2, arguments), b(e).getTime() - b(t).getTime();
}
var E = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, _ = "trunc";
function N(e) {
  return e ? E[e] : E[_];
}
function U(e, t, o) {
  y(2, arguments);
  var n = C(e, t) / j;
  return N(o?.roundingMethod)(n);
}
const g = (e) => {
  if (!e || !e.length || e.split(".").length !== 3)
    return null;
  const t = e.split(".")[1];
  return JSON.parse(window.atob(t));
}, P = (e) => {
  const t = g(e);
  return t ? t.exp * 1e3 < Date.now() : !0;
};
let v;
const $ = (e) => {
  v = e;
}, r = (...e) => {
  v && console.log(...e);
}, m = "aegisAccessToken", S = "aegisRefreshToken", d = () => ({
  accessToken: localStorage.getItem(m),
  refreshToken: localStorage.getItem(S)
}), h = (e) => {
  localStorage.setItem(m, e.accessToken), localStorage.setItem(S, e.refreshToken);
}, I = () => {
  localStorage.removeItem(m), localStorage.removeItem(S);
}, M = async () => {
  if (r("[Auth] checkAccessToken called"), l)
    return r("[Auth] checkAccessToken: refreshTokenPromise exists, waiting..."), await l, r("[Auth] checkAccessToken: finished waiting for refreshTokenPromise", d()), !0;
  const { accessToken: e } = d();
  return e ? g(e) ? P(e) ? (r("[Auth] checkAccessToken: accessToken is expired, going to refresh..."), f()) : (r("[Auth] checkAccessToken: accessToken is not expired, returning."), !0) : (console.error("Invalid access token"), I(), !1) : (r("[Auth] checkAccessToken - no access token"), !1);
}, k = async () => {
  const e = await i(), { refreshToken: t } = d();
  t && await fetch(`${e}/logout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ refreshToken: t }),
    credentials: "include"
  }), I();
}, R = async () => {
  try {
    const e = await i(), { refreshToken: t } = d();
    r(`[Auth] refreshAccessToken url: ${e}`);
    const n = await (await fetch(`${e}/refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ refreshToken: t }),
      credentials: "include"
    })).json();
    if (n.error)
      return k();
    h({
      accessToken: n.accessToken,
      refreshToken: n.refreshToken
    });
  } catch (e) {
    console.error("Error:", e), k();
  }
}, f = async () => {
  O(R()), await l, O(null);
}, p = 6e4, u = async () => {
  r("[Auth] Init called");
  const { accessToken: e } = d();
  if (!e) {
    console.error("[Auth] init - no access token");
    return;
  }
  const t = g(e);
  if (!t)
    return console.error("Invalid access token"), k();
  const o = (t.exp - t.iat) / 3 * 1e3, n = o / 1e3 / 60;
  r("[Auth] Buffer in ms:", o), r("[Auth] Buffer in min:", n);
  const s = o * 2, a = U(t.exp * 1e3, /* @__PURE__ */ new Date(), {
    roundingMethod: "floor"
  });
  r(`[Auth] Access token expires in ${a} min`), a <= n ? (r("[Auth] Refreshing token"), l ? (r("[Auth] Refreshing token"), await l) : f(), r(`[Auth] Creating setInterval for ${s / p} min`), setInterval(async () => {
    l ? (r("[Auth] Refreshing token (inside if-setInterval) - waiting for refreshTokenPromise"), await l) : f();
  }, s)) : (r(
    `[Auth] Creating setTimeout with ${a - n} min until refresh`
  ), setTimeout(
    async () => {
      r("[Auth] - setTimeout running, refresh token"), l ? (r("[Auth] - setTimeout, waiting for refreshTokenPromise"), await l) : f(), r(`[Auth] - Creating setInterval for ${s / p} min`), setInterval(async () => {
        l ? (r(
          "[Auth] Refreshing token (inside else-setInterval) - waiting for refreshTokenPromise"
        ), await l) : f();
      }, s);
    },
    (a - n) * p
  ));
}, z = async (e) => {
  const t = await i(), o = await fetch(`${t}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), n = await o.json();
  if (!o.ok)
    throw new Error(n.error || "Sign in failed");
  return n.mfaRequired || n.accessToken && n.refreshToken && (h({
    accessToken: n.accessToken,
    refreshToken: n.refreshToken
  }), await u()), n;
}, K = async (e) => {
  const t = await i(), o = await fetch(`${t}/signup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), n = await o.json();
  if (!o.ok)
    throw new Error(n.error || "Sign up failed");
  return h({
    accessToken: n.accessToken,
    refreshToken: n.refreshToken
  }), await u(), n;
}, L = async (e) => {
  const t = await i(), o = await fetch(`${t}/forgot-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), n = await o.json();
  if (!o.ok)
    throw new Error(n.error || "Forgot password request failed");
}, q = async (e) => {
  const t = await i(), o = await fetch(`${t}/reset-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), n = await o.json();
  if (!o.ok)
    throw new Error(n.error || "Reset password failed");
  return n;
}, G = async (e) => {
  const t = await i(), o = await fetch(`${t}/validate-reset-token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), n = await o.json();
  if (!o.ok)
    throw new Error(n.error || "Validate reset token failed");
  return n;
}, W = async () => {
  const e = await i(), { accessToken: t } = d();
  if (!t)
    throw new Error("Not authenticated");
  const o = await fetch(`${e}/setup-mfa`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${t}`
    },
    credentials: "include"
  }), n = await o.json();
  if (!o.ok)
    throw new Error(n.error || "Setup MFA failed");
  return n;
}, H = async (e) => {
  const t = await i(), { accessToken: o } = d(), n = {
    "Content-Type": "application/json"
  };
  o && (n.Authorization = `Bearer ${o}`);
  const s = await fetch(`${t}/verify-mfa`, {
    method: "POST",
    headers: n,
    body: JSON.stringify(e),
    credentials: "include"
  }), a = await s.json();
  if (!s.ok)
    throw new Error(a.error || "Verify MFA failed");
  return a.accessToken && a.refreshToken && (h({
    accessToken: a.accessToken,
    refreshToken: a.refreshToken
  }), await u()), a;
}, Y = async (e) => {
  const t = await i(), { accessToken: o } = d();
  if (!o)
    throw new Error("Not authenticated");
  const n = await fetch(`${t}/disable-mfa`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${o}`
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), s = await n.json();
  if (!n.ok)
    throw new Error(s.error || "Disable MFA failed");
  return s;
}, Q = async () => {
  const e = await i(), { accessToken: t } = d();
  if (!t)
    throw new Error("Not authenticated");
  const o = await fetch(`${e}/sessions`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${t}`
    },
    credentials: "include"
  }), n = await o.json();
  if (!o.ok)
    throw new Error(n.error || "Get sessions failed");
  return n;
}, X = async (e) => {
  const t = await i(), { accessToken: o } = d();
  if (!o)
    throw new Error("Not authenticated");
  const n = await fetch(`${t}/revoke-session`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${o}`
    },
    body: JSON.stringify(e),
    credentials: "include"
  }), s = await n.json();
  if (!n.ok)
    throw new Error(s.error || "Revoke session failed");
  return s;
}, Z = async () => {
  const e = await i(), { accessToken: t } = d();
  if (!t)
    throw new Error("Not authenticated");
  const o = await fetch(`${e}/revoke-all-sessions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${t}`
    },
    credentials: "include"
  }), n = await o.json();
  if (!o.ok)
    throw new Error(n.error || "Revoke all sessions failed");
  return n;
}, J = (e = 64) => {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789._~-", o = crypto.getRandomValues(new Uint8Array(e));
  return Array.from(o).map((n) => t[n % t.length]).join("");
}, x = async (e) => {
  const o = new TextEncoder().encode(e), n = await crypto.subtle.digest("SHA-256", o);
  return btoa(String.fromCharCode(...new Uint8Array(n))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};
let A = null;
const F = (e) => {
  A = e;
}, V = () => A, B = () => {
  A = null;
}, ee = async (e) => {
  const t = J(), o = await x(t), n = crypto.randomUUID();
  F(t);
  const s = new URLSearchParams({
    client_id: e.clientId,
    response_type: "code",
    redirect_uri: e.redirectUri,
    code_challenge: o,
    code_challenge_method: "S256",
    state: n,
    ...e.scope && { scope: e.scope }
  }), c = `${await i()}/oauth/authorize?${s.toString()}`;
  return r(`[Auth] OAuth flow started, auth URL: ${c}`), { authUrl: c, codeVerifier: t };
}, te = async (e, t, o) => {
  const n = V();
  if (!n)
    throw new Error("No code verifier found. OAuth flow was not started properly.");
  const s = await i(), a = await fetch(`${s}/oauth/token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      grant_type: "authorization_code",
      client_id: o,
      code: e,
      redirect_uri: t,
      code_verifier: n
    }),
    credentials: "include"
  }), c = await a.json();
  if (B(), !a.ok || c.error)
    throw new Error(c.error_description || c.error || "Token exchange failed");
  return h({
    accessToken: c.access_token,
    refreshToken: c.refresh_token
  }), await u(), r("[Auth] OAuth tokens received and stored successfully"), {
    accessToken: c.access_token,
    refreshToken: c.refresh_token,
    userId: c.user_id,
    email: c.email
  };
};
let l = null;
const O = (e) => {
  l = e;
};
let T = "";
const i = async () => new Promise((e) => {
  const t = setInterval(() => {
    T && (clearInterval(t), e(T));
  }, 500);
}), ne = async (e) => ($(e.debug || !1), T = e.url, r("[Auth] setupAuth called"), await M() && await u(), D()), D = () => {
  const { accessToken: e, refreshToken: t } = d();
  return !!(e && t);
};
export {
  T as apiUrl,
  M as checkAccessToken,
  Y as disableMfa,
  te as exchangeCodeForTokens,
  L as forgotPassword,
  i as getApiUrl,
  Q as getSessions,
  d as getTokens,
  D as isSignedIn,
  l as refreshTokenPromise,
  q as resetPassword,
  Z as revokeAllSessions,
  X as revokeSession,
  O as setRefreshTokenPromise,
  ne as setupAuth,
  W as setupMfa,
  z as signin,
  k as signout,
  K as signup,
  ee as startOAuthFlow,
  G as validateResetToken,
  H as verifyMfa
};
